// Exact weekly value in billions, rounded once at display time (falls back to the stored rounded field).
export function weekValueBn(w) {
  if (!w) return null;
  if (w.total_aed != null) return Number(w.total_aed) / 1e9;
  return w.total_aed_bn ?? null;
}

// Owner decision (2026-10-24), applies to 2026-W42 ONLY: DLD record 11-31149-2026
// (AED 919,789,428, 70.74 sqm 1 B/R) is not shown; the week's second-biggest DLD sale is shown instead.
const W42_BIGGEST_SALE = {
  value_aed: 112320000, area: "Palm Jabal Ali", rooms: null, project: null,
  date: "2026-10-15", is_offplan: false,
};

export function displayBiggestSale(w) {
  if (!w) return null;
  return w.iso_week === "2026-W42" ? W42_BIGGEST_SALE : w.biggest_sale;
}
